import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import type { CustomerResetPasswordRequest } from './model/CustomerResetPasswordRequest';

export const useCustomerResetPassword = (): UseMutationResult<
    unknown,
    unknown,
    CustomerResetPasswordRequest
> => useBffPostMutation<unknown, CustomerResetPasswordRequest>('/customers/reset-password');
